<ui-panel class="incarceration-panel" width="fill" [appTerminologyIdentity]="sectionUsage.heading" [panelTitle]="sectionText.heading()" [title]="sectionText.heading()">
  <p *ngIf="isLoading()" class="incarceration-panel__state" data-testid="loading-state">Loading incarceration history...</p>

  <p *ngIf="hasError()" class="incarceration-panel__state incarceration-panel__state--error" data-testid="error-state">
    Incarceration history is temporarily unavailable.
  </p>

  <p *ngIf="isEmpty()" class="incarceration-panel__state" data-testid="empty-state">No incarceration history on file.</p>

  <ng-container *ngIf="!isLoading() && !hasError() && terms().length > 0">
    <ol class="incarceration-timeline" data-testid="timeline">
      <li
        *ngFor="let term of terms()"
        class="incarceration-timeline__item"
        [class.is-current]="term.isCurrent"
        [attr.data-event]="term.eventTypeCode"
      >
        <span class="incarceration-timeline__marker" aria-hidden="true"></span>
        <div class="incarceration-timeline__body">
          <div class="incarceration-timeline__row">
            <span class="incarceration-timeline__facility">{{ term.facilityLabel }}</span>
            <span *ngIf="term.isCurrent" class="incarceration-timeline__current" data-testid="current-tag">Current</span>
          </div>
          <div class="incarceration-timeline__meta">
            <span *ngIf="term.securityLevel">{{ term.securityLevel }}</span>
            <span class="incarceration-timeline__dates">
              {{ term.startedOn | date: "MM/dd/yyyy" }} -
              {{ term.endedOn ? (term.endedOn | date: "MM/dd/yyyy") : "Present" }}
            </span>
          </div>
          <p *ngIf="term.movementReason" class="incarceration-timeline__reason">{{ term.movementReason }}</p>
        </div>
      </li>
    </ol>
  </ng-container>
</ui-panel>
